import { OccurenceListCommentsComponent } from './occurence-list-comments/occurence-list-comments.component';
import { OccurenceDatesComponent } from './occurence-dates/occurence-dates.component';
import { OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { OccurencesService } from '../occurences.service';
import { Occurence } from '../model/occurence.model';
import { MatDialogRef, MatBottomSheet } from '@angular/material';
import { Observable } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { DateOccurrenceType } from '../model/date-occurrence-type.model';
import { OccurenceStatus } from '../model/occurence-status.model';
import { AlertService } from '../../shared/alert/alert.service';
import { SnackbarService } from '../../../app/shared/services/snackbar.service';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { UtilService } from '../../shared/utils';
import { CONSTANTS } from '@app/shared/constants';
import { OccurenceTypesComponent } from '@app/occurences/add-occurence-modal/occurence-types/occurence-types.component';
import { OccurenceDataComponent } from '@app/occurences/add-occurence-modal/occurence-data/occurence-data.component';
var AddOccurenceModalComponent = /** @class */ (function () {
    function AddOccurenceModalComponent(matDialogData, formBuilder, occurenceService, dialogRef, authService, alertService, _snackbarService, bottomSheet, utils) {
        var _this = this;
        this.matDialogData = matDialogData;
        this.formBuilder = formBuilder;
        this.occurenceService = occurenceService;
        this.dialogRef = dialogRef;
        this.authService = authService;
        this.alertService = alertService;
        this._snackbarService = _snackbarService;
        this.bottomSheet = bottomSheet;
        this.utils = utils;
        this.comments = new Array();
        this.value = 0;
        this.showLoading = false;
        this.isCreate = false;
        this.isRead = false;
        this.haveDownloads = true;
        this.typesSelectedList = new Array();
        this.occurenceTypes = new Array();
        this.SINGLE_DATE = 'única data';
        this.MULTIPLE_DATES = 'múltiplas datas';
        this.INIT_STATUS_NAME = 'Aberto';
        this.occurrenceView = false;
        this.filesSelected = [];
        this.hasSubmitted = false;
        this.showListComments = false;
        this.ocurrenceWasSaved = false;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    }
    AddOccurenceModalComponent.prototype.ngOnInit = function () {
        this.setDefaultOption();
        this.dialogRef.disableClose = true;
        this.commentsOccurrenceForm = this.formBuilder.group({
            comments: ['', [Validators.required, Validators.maxLength(1500)]]
        });
        this.occurrenceForm = this.formBuilder.group({
            id: [''],
            description: ['', Validators.maxLength(2000)],
            dataForm: this.formBuilder.group({
                fName: [{ value: '', disabled: this.isRead }, Validators.required],
                fCpfCnpj: [{ value: '', disabled: this.isRead }, [Validators.required, this.cpfCnpjValidator]],
                fCode: [{ value: '', disabled: this.isRead }],
                fundNumber: [''],
                statusDemanda: [''],
            }, {
                updateOn: 'submit'
            }),
            datesForm: this.formBuilder.group({
                fRbDate: [{ value: this.SINGLE_DATE, disabled: this.isRead }, [Validators.required]],
                dateArray: this.formBuilder.array([]),
                dateArrayFinal: this.formBuilder.array([])
            }),
            typesForm: this.formBuilder.group({
                typesListControl: ['', this.validateMinSelected]
            }, {
                updateOn: 'submit'
            }),
            filesForm: this.formBuilder.group({
                files: ['']
            })
        });
        if (this.isRead) {
            this.manageOccurrence(this.matDialogData);
        }
        this.setConfirmOnCloseModal();
    };
    AddOccurenceModalComponent.prototype.setDefaultOption = function () {
        if (this.matDialogData && Object.keys(this.matDialogData).length > 0) {
            this.isRead = true;
            this.isCreate = false;
        }
        else {
            this.isCreate = true;
            this.isRead = false;
        }
    };
    AddOccurenceModalComponent.prototype.setConfirmOnCloseModal = function () {
        var _this = this;
        this.dialogRef.backdropClick().subscribe(function (response) {
            _this.askSureBeforeClose();
        });
    };
    AddOccurenceModalComponent.prototype.manageNewComment = function (newComments) {
        if (newComments) {
            this.showListComments = true;
            this.occurrenceListChild.loadComments();
            if (this.matDialogData.hasComments > 0) {
                this.matDialogData.hasComments++;
            }
            else {
                this.matDialogData.hasComments = 1;
            }
        }
    };
    AddOccurenceModalComponent.prototype.manageOccurrence = function (occurrenceData) {
        this.occurrenceForm.controls['id'].setValue(occurrenceData.id);
        var dataPatchValue = {
            dataForm: {
                fName: occurrenceData.fundName,
                fCpfCnpj: occurrenceData.fundCnpjCpf,
                fCode: occurrenceData.fundCode,
                statusDemanda: occurrenceData.occurrenceStatus.name
            }
        };
        this.occurrenceForm.patchValue(dataPatchValue);
        this.occurrenceForm.controls['description'].setValue(occurrenceData.description);
        this.occurrenceForm.controls['description'].disable();
        if (occurrenceData.hasComments > 0) {
            this.showListComments = true;
        }
        // - Check if have more than one date.
        if (Array.isArray(occurrenceData.dateOccurrenceTypes) && occurrenceData.dateOccurrenceTypes.length > 0) {
            var isNotUniqueDate = occurrenceData.dateOccurrenceTypes.map(function (item) { return item.suggestedDate; }).filter(function (value, index, self) { return self.indexOf(value) === index; }).length > 1;
            if (isNotUniqueDate) {
                // - Multiple date.
                this.occurrenceForm.patchValue({ datesForm: { fRbDate: this.MULTIPLE_DATES } });
            }
            else {
                // - Single date.
                this.occurrenceForm.patchValue({ datesForm: { fRbDate: this.SINGLE_DATE } });
            }
        }
        if (!occurrenceData.storedDocument || (occurrenceData.storedDocument && occurrenceData.storedDocument.length === 0)) {
            this.haveDownloads = false;
        }
        if (Array.isArray(occurrenceData.storedDocument) && occurrenceData.storedDocument.length > 0) {
            this.filesSelected = occurrenceData.storedDocument;
        }
        this.instanceTypesChecked = occurrenceData.dateOccurrenceTypes;
        this.comments = occurrenceData.occurrenceComments;
        this.occurrenceId = occurrenceData.id;
    };
    Object.defineProperty(AddOccurenceModalComponent.prototype, "dateArray", {
        get: function () {
            return this.occurrenceForm.get('datesForm').get('dateArray');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddOccurenceModalComponent.prototype, "dateArrayFinal", {
        get: function () {
            return this.occurrenceForm.get('datesForm').get('dateArrayFinal');
        },
        enumerable: true,
        configurable: true
    });
    AddOccurenceModalComponent.prototype.listTypes = function (e) {
        this.typesSelectedList = new Array();
        this.typesSelectedList.push(e);
    };
    AddOccurenceModalComponent.prototype.occurenceTypesChange = function (e) {
        this.occurenceTypes = new Array();
        this.occurenceTypes.push(e);
    };
    AddOccurenceModalComponent.prototype.onSubmit = function () {
        if (this.occurrenceForm.invalid) {
            this.occurrenceForm.get('dataForm').markAsTouched({ onlySelf: false });
            return;
        }
        this.typeModel = '';
        this.createOccurence(this.buildOccurrence(), this.occurrenceForm.get('filesForm').get('files').value);
    };
    AddOccurenceModalComponent.prototype.enableDataFields = function (event) {
        if (event) {
            this.occurrenceForm.get('dataForm').enable();
        }
        else {
            this.occurrenceForm.get('dataForm').disable();
        }
    };
    AddOccurenceModalComponent.prototype.disableFieldsAfterCreate = function (entity) {
        this.occurrenceTypesChild.disableAllCheckboxes();
        this.occurrenceForm.get('description').disable();
        this.occurrenceForm.get('dataForm').disable();
        this.occurrenceForm.get('datesForm').disable();
        this.occurrenceForm.get('typesForm').disable();
        this.occurrenceDataChild.disableFields();
    };
    AddOccurenceModalComponent.prototype.createOccurence = function (occurrence, filesToUpload) {
        var _this = this;
        this.showLoading = true;
        var msg = '';
        this.occurenceService.createOccurence(occurrence, filesToUpload).subscribe(function (event) {
            msg = 'Sua solicitação foi realizada com sucesso!';
            _this.showLoading = false;
            _this._snackbarService.showSnackbar(msg, 'OK');
            _this.disableFieldsAfterCreate(occurrence);
            _this.ocurrenceWasSaved = true;
        }, function (err) {
            msg = "Solicita\u00E7\u00E3o n\u00E3o processada!\n        Por favor, tente novamente. Caso o problema persista, contate o seu canal de atendimento.";
            _this.showLoading = false;
            _this._snackbarService.showSnackbar(msg, 'OK');
            _this.ocurrenceWasSaved = false;
        }, function () {
            _this.hasSubmitted = true;
        });
    };
    AddOccurenceModalComponent.prototype.buildOccurrence = function () {
        //Status
        var occurrenceStatus = new OccurenceStatus(null, this.INIT_STATUS_NAME, null, null);
        //Fund
        var fundName = this.occurrenceForm.get('dataForm').get('fName').value;
        var tradeName = this.occurrenceForm.get('dataForm').get('fName').value;
        var fundCnpjCpf = this.occurrenceForm.get('dataForm').get('fCpfCnpj').value;
        var fundCode = this.occurrenceForm.get('dataForm').get('fCode').value;
        var fundNumber = this.occurrenceForm.get('dataForm').get('fundNumber').value;
        var description = this.occurrenceForm.get('description').value;
        //Occurrence
        var id = null;
        var creationDateTime = null;
        var userName = this.authUser.gestor;
        var typesListControl = this.occurrenceForm.get('typesForm').get('typesListControl').value;
        var dateOccurrenceTypes = new Array();
        for (var _i = 0, _a = typesListControl.map(function (item, index) { return ({ item: item, index: index }); }); _i < _a.length; _i++) {
            var _b = _a[_i], item = _b.item, index = _b.index;
            var suggestedDate = null;
            var approvedDate = null;
            if (this.occurrenceForm.get('datesForm').get('fRbDate').value === this.SINGLE_DATE) {
                suggestedDate = this.dateArray.at(0).value;
                approvedDate = this.dateArrayFinal.at(0).value;
            }
            else {
                suggestedDate = this.dateArray.at(index).value;
                approvedDate = this.dateArrayFinal.at(index).value;
            }
            //DateOccurrenceType
            var dateOccurrenceTypeId = null;
            var updateDateTime = null;
            var dateOccurrenceType = new DateOccurrenceType(dateOccurrenceTypeId, item, id, updateDateTime, suggestedDate, approvedDate);
            dateOccurrenceTypes.push(dateOccurrenceType);
        } //end for
        var occurence = new Occurence(id, creationDateTime, tradeName, userName, fundName, fundCnpjCpf, fundCode, description, occurrenceStatus, dateOccurrenceTypes, [], fundNumber);
        return occurence;
    };
    AddOccurenceModalComponent.prototype.multipleDate = function (isMultiple) {
        return isMultiple;
    };
    AddOccurenceModalComponent.prototype.validateMinSelected = function (control) {
        if (control.value) {
            if (control.value.length < 1) {
                return { "validateMinSelected": true };
            }
        }
        else {
            return { "validateMinSelected": true };
        }
        return null;
    };
    AddOccurenceModalComponent.prototype.cpfCnpjValidator = function (control) {
        if (control.value) {
            if (control.value != "" && !OccurencesService.cpfCnpjValidator(control.value)) {
                return { 'cpfCnpjValidator': true };
            }
        }
        return null;
    };
    AddOccurenceModalComponent.prototype.onKeyUp = function () {
        this.askSureBeforeClose();
    };
    AddOccurenceModalComponent.prototype.askSureBeforeClose = function () {
        var _this = this;
        if (this.commentsOccurrenceForm.get('comments').value != '') {
            this.bottomSheet.open(ConfirmDialogComponent, {
                data: { message: 'As alterações não serão enviadas. Deseja continuar?' }
            }).afterDismissed().subscribe(function (data) {
                if (data && data.message === 'Confirm') {
                    _this.dialogRef.close();
                }
            });
        }
        else {
            this.dialogRef.close();
        }
    };
    AddOccurenceModalComponent.prototype.closeModal = function () {
        this.askSureBeforeClose();
    };
    // verifica se o retorno da requisição foi success
    AddOccurenceModalComponent.prototype.isSuccess = function () {
        return this.typeModel == 'success';
    };
    // verifica se o retorno da requisição foi error
    AddOccurenceModalComponent.prototype.isError = function () {
        return this.typeModel == 'error';
    };
    AddOccurenceModalComponent.prototype.validateWallet = function () {
        var data = this.occurrenceForm.get('dataForm').get('fName').value;
        var containsInputWallet = document.getElementById('mySelectNameField') !== null;
        if (!data && containsInputWallet) {
            this._snackbarService.showSnackbar(CONSTANTS.INFO_REQUIRED_PORTFOLIO, CONSTANTS.GLOBAL.OK);
            return false;
        }
    };
    return AddOccurenceModalComponent;
}());
export { AddOccurenceModalComponent };
